// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bts-form-tabs .nav-tabs {\n  margin-left: 10px;\n  border-bottom: none !important;\n}\n.bts-form-tabs .nav-tabs .nav-item a.active {\n  border-bottom: 1px solid #0056b3;\n}\n.bts-form-tabs .tab-content {\n  height: auto !important;\n  border-top: 1px solid #dee2e6;\n}\n.is-disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
